import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=3dc6104c&scoped=true"
import script from "./ProjectsList.vue?vue&type=script&lang=js"
export * from "./ProjectsList.vue?vue&type=script&lang=js"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=3dc6104c&prod&lang=less&scoped=true"
import style1 from "./ProjectsList.vue?vue&type=style&index=1&id=3dc6104c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6104c",
  null
  
)

export default component.exports